module.exports = __webpack_public_path__ + "img/rc.10872e02.png";